module.exports = __webpack_public_path__ + "img/bc카드.bd9292d6.png";